import React, { Component } from "react";
import MenuItem from "material-ui/MenuItem";

const styles = {
  style: {
    fontSize: "1em",
    lineHeight: "1.5em",
    padding: ".5em 0",
    fontWeight: "300",
    color: "#ed135d"
  },
  innerDivStyle: {
    padding: "0 2em 0 1em"
  },
  tickIconStyle: {
    right: "0.5em",
    top: "50%",
    margin: "-0.5em 0 0",
    fontSize: "1em"
  }
};

class Option extends Component {
  render() {
    const { selected } = this.props;
    return (
      <MenuItem
        {...this.props}
        style={styles.style}
        innerDivStyle={styles.innerDivStyle}
        rightIcon={
          selected ? (
            <i className="material-icons" style={styles.tickIconStyle}>
              done
            </i>
          ) : null
        }
        onClick={this.props.onClick}
      />
    );
  }
}

Option.muiName = "MenuItem";
Option.defaultProps = {
  className: "menu-item"
};

export { Option };



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Shared/Option.js